// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zt-0";
export var tagInputDisabled = "_zt-1";